if ( typeof MainHeader !== 'function' ) {

	class MainHeader extends HTMLElement {

		constructor(){
			super();
			this.mount();
			this.body = document.querySelector('body');
		}

		mount(){
			/* -- > DRAWERS < -- */
			document.querySelectorAll('#main > div').forEach(elm=>{
				if ( ! elm.classList.contains('no-inert') ) {
					elm.setAttribute('data-js-inert', '');
				}
			})
			window.inertElems = document.querySelectorAll('[data-js-inert]');

			let ticking = false;

			const overlay = document.getElementById('gnb--overlay');
			if(overlay) {
				document.addEventListener('scroll', (e) => {
					if (!ticking) {
						requestAnimationFrame(() => {
							
							let announcement_bar = document.querySelector('.section-announcement-bar');
							let header_top = document.querySelector('.header-container--top').offsetHeight;
	
							if (announcement_bar.style.display !== 'none') {
								header_top += announcement_bar.offsetHeight;
							}
							let logo_bottom = document.querySelector('#logo_pc_bottom');
	
							if (window.scrollY > header_top) {
								overlay.style.display = 'block';
								logo_bottom.style.display = 'block';
							} else {
								overlay.style.display = 'none';
								logo_bottom.style.display = 'none';
							}
	
							ticking = false;
						});
	
						ticking = true;
					}
				});
			}

			// drawer connections
			document.querySelectorAll('[data-js-sidebar-handle]').forEach(elm => {
				if ( elm.hasAttribute('aria-controls') ) {
					let aria = elm.getAttribute('aria-controls');

					const elmSidebar = document.getElementById(aria);
					elm.addEventListener('click', e=>{
						e.preventDefault();
						elm.setAttribute('aria-expanded', 'true');
						elmSidebar.show();

						document.querySelector('.site-header-container').classList.add('mobile-slide-open');

					});

					elm.addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							elm.setAttribute('aria-expanded', 'true');
							elmSidebar.show();
							elmSidebar.querySelector('[data-js-close]').focus();
						}
					});
				}
			});
			if ( this.classList.contains('site-header--alignment-left') ) {
				document.getElementById('site-search-sidebar').classList.remove('sidebar--left');
				document.getElementById('site-search-sidebar').classList.add('sidebar--right');
			}
			
			// closing drawers
			document.querySelectorAll('sidebar-drawer [data-js-close]').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					let target_sidebar = e.target.closest('.sidebar');
					if ( target_sidebar.classList.contains('sidebar--opened') ) {
						target_sidebar.hide();
						document.querySelector('.site-header-container').classList.remove('mobile-slide-open');
						document.querySelector(`[aria-controls="${target_sidebar.id}"]`).setAttribute('aria-expanded', 'false');
					}
				});
			});
			
			document.querySelector('.site-overlay').addEventListener('click', (e)=>{
				e.preventDefault();
				
				if ( this.body.classList.contains('gnb-opened') ) {
					this.body.classList.remove('gnb-opened');
				}
				if ( document.querySelector('.style--classic .has-submenu.focus') ) {
					document.querySelector('.style--classic .has-submenu.focus').classList.remove('focus');
				}

				let opened_sidebar = document.querySelector('.sidebar.sidebar--opened');
				if ( opened_sidebar ) {
					opened_sidebar.hide();
					document.querySelector('.site-header-container').classList.remove('mobile-slide-open');
					document.querySelector(`[aria-controls="${opened_sidebar.id}"]`).setAttribute('aria-expanded', 'false');
				}
				if(document.querySelector('.no-checked-txt')) {
					document.querySelector('.no-checked-txt').classList.remove('active');
				}
			});

			// blur
			let blurLiEl = document.querySelectorAll('#menu-item-shop-classic, #menu-item-about-sidiz-classic, #menu-item-support-classic');

			blurLiEl.forEach(el => {
				el.addEventListener('mouseenter', e=>{
					if (this.body.classList.contains('no-touchevents')) {
						this.body.classList.add('gnb-opened');
					}
				});
				el.addEventListener('mouseleave', e=>{
					if (this.body.classList.contains('no-touchevents')) {
						if (!document.querySelector('.has-submenu.focus')) {
							this.body.classList.remove('gnb-opened');
						}
					}
				});
			});
			// touch menu helpers
			const closeTouchSubmenus = (focusedElm, focusedParent=null)=>{
				document.querySelectorAll('.style--classic li.focus').forEach(elm=>{
					if ( ! ( elm === focusedElm || elm === focusedParent ) ) {
						elm.classList.remove('focus');
					}
				});
			}

			const hasSubMenu = document.querySelectorAll('.style--classic .has-submenu');
			hasSubMenu.forEach(elm=>{
				elm.addEventListener('click', e=>{
					elm.classList.toggle('focus');
					if (elm.classList.contains('focus')) {
						this.body.classList.add('gnb-opened');
					} 
					else {
						this.body.classList.remove('gnb-opened');
					}
					closeTouchSubmenus(elm);
				});
				// 제갈민혁 - 02.21 GNB 마우스 hover 하고 거래명세서,대량구매문의 클릭시 GNB가 닽히지 않아 추가 했습니다!
				elm.querySelectorAll('.has-submenu > ul').forEach(item => {
					item.addEventListener('click', e => {
						// 부모 메뉴에 focus가 없을 경우만 focus 추가
						if (!elm.classList.contains('focus')) {
							elm.classList.add('focus');
							// gnb-opened는 추가되지 않음
						}
						closeTouchSubmenus(elm);
					});
				});
			});
			
			// resizing drawers
			const rootHeight = document.getElementById('root-height');
			this.RESIZE_SidebarHelper = debounce(()=>{
				rootHeight.innerHTML = `:root {
					--window-height: ${window.innerHeight}px;
					--window-width: ${document.body.clientWidth}px;
				}`;
			}, 200);
			window.addEventListener('resize', this.RESIZE_SidebarHelper);
			rootHeight.innerHTML = `:root {
				--window-height: ${window.innerHeight}px;
				--window-width: ${document.body.clientWidth}px;
			}`;
			document.body.classList.add('header-loaded');

			// predictive search

			if ( JSON.parse(document.getElementById('shopify-features').text).predictiveSearch ) {

				// predictive search (sidebar)

				document.querySelectorAll('[data-js-open-search-drawer').forEach(elm=>{
					elm.addEventListener('click', e=>{
						e.preventDefault();
						if ( ! document.body.classList.contains('predictive-script-loaded') ) {
							document.body.classList.add('predictive-script-loaded')
							const predictiveSearchJS = document.createElement('script');
							predictiveSearchJS.src = KROWN.settings.predictive_search_script;
							document.head.appendChild(predictiveSearchJS); 
						}
						setTimeout(()=>{
							document.querySelector('#search-form-sidebar').focus();
						}, 10)
					});
				});

			} else {
				if(this.querySelector('search-form')) {
					this.querySelector('search-form').addEventListener('click', e=>{
						e.preventDefault();
						window.location.href = KROWN.settings.routes.search_url;
					});
				}
			}
		}

		getOS() {
			const userAgent = window.navigator.userAgent.toLowerCase();
			if (userAgent.includes("win")) return "windows";
			if (userAgent.includes("mac")) return "macos";
			if (userAgent.includes("linux")) return "linux";
			return "unknown";
		}

		unmount(){
			window.removeEventListener('resize', this.RESIZE_SidebarHelper);
		}

	}
	
  if ( typeof customElements.get('main-header') == 'undefined' ) {
		customElements.define('main-header', MainHeader);
	}

}

if ( typeof SidebarDrawer !== 'function' ) {

	class SidebarDrawer extends HTMLElement {

		constructor(){
			super();
			if(this.querySelector('[data-js-close]')) {
				this.querySelector('[data-js-close]').addEventListener('click', ()=>{
					// 카트일 경우 no-checked-txt 비활성화
					if(document.querySelector('.no-checked-txt')) {
						document.querySelector('.no-checked-txt').classList.remove('active');
					}
					this.hide();
				});
			}
		}

		/* generic hide/show functions */
		show(){

			this._opened = true;
			document.body.classList.add('sidebar-opened');
			if ( this.classList.contains('sidebar--right') ) {
				document.body.classList.add('sidebar-opened--right');
			} else if ( this.classList.contains('sidebar--left') ) {
				document.body.classList.add('sidebar-opened--left');
			}
			if ( this.id == 'site-cart-sidebar' && document.getElementById('cart-recommendations-sidebar') ) {
				setTimeout(()=>{
					document.querySelector('#cart-recommendations-sidebar css-slider')?.resetSlider();
				}, 10);
			}

			this.style.display = 'grid';
			setTimeout(()=>{
				this.classList.add('sidebar--opened');
				window.inertElems.forEach(elm=>{
					elm.setAttribute('inert', '');
				})
			}, 15);

			if(this.id == 'site-cart-sidebar') {
				// 통계 수집 오류가 장바구니 표시를 중단하지 않도록 분리합니다.
				try {
					this.trackCartView();
				} catch (error) {
					console.warn('장바구니 조회 통계 전송 실패', error);
				}
			}

		}

		trackCartView(){
			if (typeof window.dataLayer?.push !== 'function') return;

			// PLUS ZERO: view_cart
			const items = this.querySelectorAll('[data-js-cart-item]');
			const items_arr = Array.from(items, item => ({
				item_id: item.dataset.sku,
				item_name: item.dataset.itemName,
				price: Number(item.dataset.itemPrice) / 100,
				quantity: Number(item.dataset.qty),
				item_brand: 'SIDIZ',
				item_category: item.dataset.itemCategory,
				item_variant: item.dataset.itemVariant,
				img_url: item.querySelector('.cart-item__thumbnail img')?.src?.split('/').pop() || ''
			}));

			// 이전 ecommerce 데이터 초기화
			window.dataLayer.push({ ecommerce: null });
			window.dataLayer.push({
				event: 'view_cart',
				page_type: window.pageType,
				ecommerce: {
					items: items_arr
				}
			});

		}

		hide(){

			this._opened = false;
			this.classList.remove('sidebar--opened');

			document.body.classList.remove('sidebar-opened');
			document.body.classList.remove('sidebar-opened--left');
			document.body.classList.remove('sidebar-opened--right');
			window.inertElems.forEach(elm=>{
				elm.removeAttribute('inert');
			})

			document.querySelector(`[aria-controls="${this.id}"]`)?.setAttribute('aria-expanded', 'false');

			setTimeout(()=>{
				this.style.display = 'none';
			}, 501);

		}

	}


  if ( typeof customElements.get('sidebar-drawer') == 'undefined' ) {
		customElements.define('sidebar-drawer', SidebarDrawer);
	}

}

if ( typeof MobileNavigation !== 'function' ) {
		
	class MobileNavigation extends HTMLElement {

		constructor() {

			super();

			this._openedFirstSubmenu = false;

			this.querySelectorAll('.has-submenu > a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = true;
						this.classList.add('opened-first-submenu')
						this.closest('sidebar-drawer').scrollTo({top: 0});
						document.querySelector('.sidebar-back-btn').style.display = 'block';
					}
					e.target.closest('li').classList.add('opened');
					this._resizeContainer();
				})
			});

			this.querySelectorAll('#SiteNavLabel-shop-sidebar .has-babymenu').forEach(elm=>{
				let cateLink = elm.querySelector('.cate-link');
				cateLink.addEventListener('click', e=>{
					e.preventDefault();
					
					let calcHeight = 0;
					if(elm.classList.contains('opened')){
						calcHeight = (elm.querySelector('.submenu-wrap').clientHeight + 16) * -1;
						elm.classList.remove('opened');
					} else {
						elm.classList.add('opened');
						calcHeight = elm.querySelector('.submenu-wrap').clientHeight + 16;
					}
					this.style.height = `${this.clientHeight + calcHeight}px`;
				})
			});

			this.querySelectorAll('.submenu-back a').forEach(elm=>{
				elm.addEventListener('click', e=>{
					if ( this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = false;
						this.classList.remove('opened-first-submenu');
						this._resizeContainer(true);
					}
					this.closest('sidebar-drawer').scrollTo({top: 0});
					setTimeout(()=>{
						e.target.closest('li.opened').classList.remove('opened');
					}, 301);
					e.preventDefault();
				})
			});

			document.querySelectorAll('.sidebar-back-btn').forEach(elm=>{
				elm.addEventListener('click', e=>{
					if ( this._openedFirstSubmenu ) {
						this._openedFirstSubmenu = false;
						this.classList.remove('opened-first-submenu');
						document.querySelector('.sidebar-back-btn').style.display = 'none';
						this._resizeContainer(true);
					}
					this.closest('sidebar-drawer').scrollTo({top: 0});
					setTimeout(()=>{
						this.querySelectorAll('li.opened').forEach(elm=>{
							elm.classList.remove('opened');
						});
					}, 301);
					e.preventDefault();
				})
			});

		}

		_resizeContainer(main=false){
			if ( main ) {
				this.style.height = `auto`;
			} else {
				if ( this._openedFirstSubmenu ) {
					this.style.height = `${this.querySelector('.opened .submenu').scrollHeight}px`;
				}  
			}
		}

	}

  if ( typeof customElements.get('mobile-navigation') == 'undefined' ) {
		customElements.define('mobile-navigation', MobileNavigation);
	}
}
